export const dataGameAppPosts = [
  {
    id: 1,
    imagePost: "https://cdn.tgdd.vn/2022/04/content/Gunny-Origin-600x360.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/2/276446/Screentshots/gunny-origin-song-lai-cam-giac-ga-game-ban-sung-toa-do-276446-logo-07-04-2022.png",
    titlePost:
      "Gunny Origin - Sống Lại Cảm Giác Gà: game bắn súng tọa độ Gunny",
  },
  {
    id: 1,
    imagePost:
      "https://cdn.tgdd.vn/2022/01/content/vua-hai-tac-cmn-600x360.jpg",
    imgTitle: "https://cdn.tgdd.vn/2022/01/GameApp/icon-200x200.jpg",
    titlePost: "Vua Hải Tặc CMN - Tái hiện thế giới One Piece siêu chân thật",
  },
  {
    id: 1,
    imagePost: "https://cdn.tgdd.vn/2021/08/content/Untitled-2-600x360.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/249053/Screentshots/3q-cmn--choi-met-nghi-249053-logo-16-08-2021.png",
    titlePost: "3Q CMN - Game thẻ tướng Tam Quốc thế hệ mới",
  },
  {
    id: 2,
    imagePost: "https://cdn.tgdd.vn/2021/05/content/Counterside-600x360.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/2/239741/Screentshots/counter-side-sieu-pham-game-the-tuong-anime-239741-logo-20-05-2021.png",
    titlePost: "Counter: Side - Siêu phẩm game thẻ tướng Anime",
  },
  {
    id: 2,
    imagePost: "https://cdn.tgdd.vn/2021/04/content/thumb-600x360-1.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/237932/Screentshots/tan-omg3q-vng-237932-logo-27-04-2021.png",
    titlePost: "Tân OMG3Q VNG - Game đấu tướng Tam Quốc thế hệ mới",
  },
  {
    id: 2,
    imagePost:
      "https://cdn.tgdd.vn/2021/04/content/vltk-1-mobile-600x360-1.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/2/236384/Screentshots/vo-lam-truyen-ky-1-mobile-236384-logo-15-04-2021.png",
    titlePost: "Võ Lâm Truyền Kỳ 1 Mobile - Huyền thoại game kiếm hiệp",
  },
];
export const dataGameAppPostsApp = [
  {
    id: 1,
    imagePost: "https://cdn.tgdd.vn/2021/02/content/meetfeat-600x360.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
    titlePost:
      "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
  },
  {
    id: 2,
    imagePost: "https://cdn.tgdd.vn/2021/02/content/zoomfeat-600x360.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
    titlePost:
      "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
  },
  {
    id: 3,
    imagePost:
      "https://cdn.tgdd.vn/2020/04/content/PicsArtPhotoEditor1-600x360-1.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
    titlePost:
      "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
  },
  {
    id: 4,
    imagePost: "https://cdn.tgdd.vn/2020/04/content/instagram-600x360.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
    titlePost:
      "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
  },
  {
    id: 5,
    imagePost: "https://cdn.tgdd.vn/2020/03/content/thum-600x360-5.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
    titlePost:
      "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
  },
  {
    id: 6,
    imagePost: "https://cdn.tgdd.vn/2020/03/content/tik-600x360.jpg",
    imgTitle:
      "https://cdn.tgdd.vn/GameApp/3/228059/Screentshots/google-meet-app-hop-truc-tuyen-hoc-online-khong-gioi-228059-logo-01-09-2020.png",
    titlePost:
      "Google Meet: App họp trực tuyến, học online không giới hạn người tham gia",
  },
];
